// Import statements

// API Base URLs
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://babynameniman.com/api';

// Asset Base URL (kapak gorselleri, yuklenen dosyalar vb. icin)
// Gelistirmede asset'leri canli host'tan cekiyoruz ANCAK dogrudan degil:
// CRA dev proxy'si (src/setupProxy.js) /uploads isteklerini canliya yonlendirir.
// Bu yuzden gelistirmede REACT_APP_ASSET_URL'i BOS birakip relative (ayni-origin)
// URL uretiriz; boylece tarayici CORP (Cross-Origin-Resource-Policy) engeline takilmaz.
// Tanimli degilse (production) API_BASE_URL kullanilir.
// Not: `??` kullaniyoruz ki bos string ("") relative URL icin gecerli kalsin.
export const ASSET_BASE_URL =
  process.env.REACT_APP_ASSET_URL != null ? process.env.REACT_APP_ASSET_URL : API_BASE_URL;

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/profile',
    VERIFY_EMAIL: '/auth/verify-email',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    GOOGLE_AUTH: '/auth/google',
    FACEBOOK_AUTH: '/auth/facebook'
  },
  
  // Suggestion endpoints
  SUGGESTIONS: {
    GENERATE: '/suggestions/generate',
    HISTORY: '/suggestions/history',
    SAVE: '/suggestions/save',
    DELETE: '/suggestions/delete',
    FAVORITE: '/suggestions/favorite'
  },
  
  // Payment endpoints
  PAYMENTS: {

    PAYPAL: '/payments/paypal',
    VERIFY: '/payments/verify',
    WEBHOOK: '/payments/webhook'
  },
  
  // Language endpoints
  LANGUAGES: {
    LIST: '/languages',
    TRANSLATIONS: '/languages/translations',
    SET_PREFERENCE: '/languages/preference'
  }
};

// Default Values
export const DEFAULT_VALUES = {
  LANGUAGE: 'de',
  CURRENCY: 'USD',
  TIMEZONE: 'Europe/Istanbul',
  ITEMS_PER_PAGE: 10,
  MAX_SUGGESTIONS: 50,
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000, // 24 hours
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000
};

// Gender Options — backend ENUM sözleşmesiyle hizalı (denetim bulgusu:
// male/female değerleri DB/AI/frontend i18n'in gerçek sözleşmesi olan
// boy/girl/unisex ile uyumsuzdu).
export const GENDER_OPTIONS = [
  { value: 'boy', label: 'Boy', icon: '👦' },
  { value: 'girl', label: 'Girl', icon: '👧' },
  { value: 'unisex', label: 'Unisex', icon: '👶' }
];

// NOT (denetim bulgusu): CREDIT_PACKAGES, CULTURE_OPTIONS, RELIGIOUS_OPTIONS,
// POPULARITY_OPTIONS, LENGTH_OPTIONS, MEANING_CATEGORIES sabitleri kaldırıldı —
// hiçbir bileşen tüketmiyordu ve değerleri ölü bir API sözleşmesini kodluyordu
// (culture: 'turkish'/'arabic' vs gerçekte 'arabWorld'/'turkeyAsia'; popularity:
// 'very_popular' vs gerçekte 'rare'/'extraordinary'/'known'/'classic').

// Supported Languages — gerçek destek 5 dil (i18n supportedLngs);
// haya 'fa' (Farsça) girdisi kaldırıldı (denetim bulgusu).
export const SUPPORTED_LANGUAGES = [
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷', rtl: false },
  { code: 'en', name: 'English', flag: '🇺🇸', rtl: false },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', rtl: false },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾', rtl: false }
];

// Payment Methods
export const PAYMENT_METHODS = [

  { id: 'paypal', name: 'PayPal', icon: '🅿️', provider: 'paypal' },


];

// Social Auth Providers
export const SOCIAL_PROVIDERS = [
  { id: 'google', name: 'Google', icon: '🟢', color: '#4285f4' },
          { id: 'facebook', name: 'Facebook', icon: '📘', color: '#1877F2' }
];

// Validation Constants
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REGEX: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
  PHONE_REGEX: /^\+?[\d\s\-()]+$/,
  USERNAME_REGEX: /^[a-zA-Z0-9_]{3,20}$/
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'Resource not found.',
  SERVER_ERROR: 'Internal server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  PAYMENT_FAILED: 'Payment failed. Please try again.',
  SESSION_EXPIRED: 'Your session has expired. Please log in again.',
  RATE_LIMIT: 'Too many requests. Please wait before trying again.'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful!',
  REGISTER_SUCCESS: 'Registration successful!',
  LOGOUT_SUCCESS: 'Logout successful!',
  PROFILE_UPDATED: 'Profile updated successfully!',
  SUGGESTION_SAVED: 'Suggestion saved successfully!',
  SETTINGS_SAVED: 'Settings saved successfully!',
  EMAIL_VERIFIED: 'Email verified successfully!',
  PASSWORD_RESET: 'Password reset successfully!'
};

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Local Storage Keys
// F3-6 / denetim #26: AUTH_TOKEN/REFRESH_TOKEN/USER_DATA ölü sabitler —
// token'lar HttpOnly cookie'de, localStorage'a asla yazılmıyor. Kaldırıldı.
export const STORAGE_KEYS = {
  LANGUAGE: 'selected_language',
  THEME: 'selected_theme',
  RECENT_SEARCHES: 'recent_searches',
  FAVORITES: 'favorite_suggestions',
  SETTINGS: 'user_settings',
  FORM_DRAFT: 'form_draft',
  PENDING_FORM: 'pending_form_data',
  REDIRECT_AFTER_AUTH: 'redirect_after_auth',
  PENDING_AI_QUERY: 'pending_ai_query',
  DRAFT_PREFERENCES: 'draft_preferences',
  MARKETING_CONSENT_PENDING: 'marketing_consent_pending',
  LEAD_MAGNET_REF: 'lead_magnet_ref',
  WELCOME_TOUR_DONE: 'welcome_tour_done',
  ACTIVE_CHAT_RETURN: 'active_chat_return'
};

// Theme Constants
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  AUTO: 'auto'
};

// Animation Durations
export const ANIMATIONS = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
  VERY_SLOW: 1000
};

// Breakpoints
export const BREAKPOINTS = {
  XS: 480,
  SM: 768,
  MD: 1024,
  LG: 1280,
  XL: 1536
};

// Z-Index Levels
export const Z_INDEX = {
  DROPDOWN: 1000,
  MODAL: 1050,
  TOOLTIP: 1100,
  TOAST: 1200,
  LOADING: 1300
};

const constants = {
  API_BASE_URL,
  API_ENDPOINTS,
  DEFAULT_VALUES,
  GENDER_OPTIONS,
  SUPPORTED_LANGUAGES,
  PAYMENT_METHODS,
  SOCIAL_PROVIDERS,
  VALIDATION,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  LOADING_STATES,
  STORAGE_KEYS,
  THEMES,
  ANIMATIONS,
  BREAKPOINTS,
  Z_INDEX
};

export default constants; 